import api from './apiLibrary';

const API = {
    // Fields
    getFields(params) {
        return api.get('/api/admin/parking/fields', params);
    },
    getField(id, params) {
        return api.get(`/api/admin/parking/fields/${id}`, params);
    },
    editField(id, data) {
        return api.patch(`/api/admin/parking/fields/${id}`, data);
    },
    // Capacity-based season fill ("erfassen" on the field page)
    seasonFill(id) {
        return api.get(`/api/admin/parking/fields/${id}/season-fill`);
    },
    fillField(id) {
        return api.post(`/api/admin/parking/fields/${id}/fill`);
    },
    // Sperrdaten (blocked dates per field — Q2 = manual)
    addSperrDate(id, data) {
        return api.post(`/api/admin/parking/fields/${id}/sperr-dates`, data);
    },
    removeSperrDate(id, sperrId) {
        return api.delete(`/api/admin/parking/fields/${id}/sperr-dates/${sperrId}`);
    },
    // Blocked-lot batch switch: status + move cards to/from the fallback lot.
    getSwitchStatus(sperrId) {
        return api.get(`/api/admin/parking/sperr-dates/${sperrId}/switch-status`);
    },
    switchBatch(sperrId, data) {
        return api.post(`/api/admin/parking/sperr-dates/${sperrId}/switch-batch`, data);
    },
    // Passes
    getPasses(params) {
        return api.get('/api/admin/parking/passes', params);
    },
    getPass(id) {
        return api.get(`/api/admin/parking/passes/${id}`);
    },
    assignAccess(accessId, data) {
        return api.post(`/api/admin/parking/passes/access/${accessId}/assign`, data);
    },
    revokeAccess(accessId) {
        return api.delete(`/api/admin/parking/passes/access/${accessId}/assign`);
    },
    // Copyable public eticket link for a per-game code (generates token, no SMS).
    shareLink(accessId) {
        return api.post(`/api/admin/parking/passes/access/${accessId}/share-link`);
    },
    // Owner (whole pass) assignment — mirrors the Abo owner model.
    assignOwner(passId, data) {
        return api.post(`/api/admin/parking/passes/${passId}/owner`, data);
    },
    unassignOwner(passId) {
        return api.delete(`/api/admin/parking/passes/${passId}/owner`);
    },
    createPass(data) {
        return api.post('/api/admin/parking/passes', data);
    },
    createBulk(data) {
        return api.post('/api/admin/parking/passes/bulk', data);
    },
    // Imports
    importCsv(data) {
        return api.post('/api/admin/parking/import/csv', data);
    },
    importPasses(data) {
        return api.post('/api/admin/parking/import/passes', data);
    },
    // Stats
    getCounts(params) {
        return api.get('/api/admin/parking/stats/counts', params);
    },
    getShowRate(params) {
        return api.get('/api/admin/parking/stats/show-rate', params);
    },
    // Per-game swipe status (used vs physical capacity per field).
    getPerGame(params) {
        return api.get('/api/admin/parking/stats/per-game', params);
    },
};

export default API;
